// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "PurchLineReturn"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = [
  {
    key: "id",
    label: "编号",
    sortable: true
  },
  {
    key: "dataAreaId",
    label: "销售公司",
    sortable: true
  },
  {
    key: "CompanyName",
    label: "销售公司名称",
    sortable: true,
    thStyle: { width: "8rem" },
    width: "8rem",
    type: "short"
  },
  {
    key: "local_PurchId",
    label: "系统采购编号",
    sortable: true,
    thStyle: {
      width: "8rem"
    },
    type: "short"
  },
  {
    key: "PurchId",
    label: "采购订单编号",
    thStyle: {
      width: "8rem"
    },
    type: "short"
  },
  {
    key: "LineNumber",
    label: "行号",
    sortable: true
  },
  {
    key: "ItemId",
    label: "物料编号",
    sortable: true
  },
  {
    key: "NameAlias",
    label: "物料名称",
    sortable: true,
    thStyle: {
      width: "12rem"
    },
    type: "short"
  },
  {
    key: "VariantName",
    label: "变型名称",
    sortable: true,
    thStyle: {
      width: "10rem"
    },
    type: "short"
  },
  {
    key: "SalesId",
    label: "平台销售订单编号",
    sortable: true
  },
  {
    key: "TEC_CustAccount",
    label: "客户账户",
    sortable: true
  },
  {
    key: "Cust_SEI_Name",
    label: "客户名称",
    sortable: true,
    thStyle: {
      width: "12rem"
    },
    type: "short"
  },
  {
    key: "AccountNum",
    label: "供应商账户",
    sortable: true
  },
  {
    key: "SEI_Name",
    label: "供应商名称",
    sortable: true
  },
  {
    key: "PurchStatus",
    label: "行状态",
    sortable: true
  },
  {
    key: "DeliveryDate",
    label: "交货日期",
    sortable: true
  },
  {
    key: "create_at",
    label: "开单日期"
  },
  {
    key: "username",
    label: "开单人"
  },
  {
    key: "TaxGroup",
    label: "销售税组",
    sortable: true
  },
  {
    key: "PurchQty",
    label: "采购数量",
    type: "number",
    _precise: 6
  },
  {
    key: "DeliveryQty",
    label: "交货数量",
    type: "number",
    _precise: 6
  },
  {
    key: "RemainPurchPhysical",
    label: "剩余交货量",
    type: "number",
    _precise: 6
  },
  {
    key: "PurchFinancial",
    label: "开票数量",
    type: "number",
    _precise: 6
  },
  {
    key: "RemainPurchFinancial",
    label: "未开票数量",
    type: "number",
    _precise: 6
  },
  {
    key: "PurchPrice",
    label: "单位价格",
    type: "number",
    _precise: 6
  },
  {
    key: "price_wotax",
    label: "本币不含税",
    type: "number",
    _precise: 6
  },
  {
    key: "CurrencyCode",
    label: "币种"
  },
  {
    key: "PurchUnit",
    label: "单位"
  },

  {
    key: "TaxItemGroup",
    label: "销售税(物料)组"
  },
  {
    key: "UnderDeliveryPct",
    label: "欠交",
    type: "number"
  },
  {
    key: "OverDeliveryPct",
    label: "超交",
    type: "number"
  }
]

const dataForm = {
  name: "",
  region: "",
  date1: "",
  date2: "",
  delivery: false,
  type: [],
  resource: "",
  desc: ""
}

///前端验证
const rules = {
  name: [
    {
      required: true,
      message: "请输入活动名称",
      trigger: "blur"
    },
    {
      min: 3,
      max: 5,
      message: "长度在 3 到 5 个字符",
      trigger: "blur"
    }
  ],
  region: [
    {
      required: true,
      message: "请选择活动区域",
      trigger: "change"
    }
  ],
  date1: [
    {
      type: "date",
      required: true,
      message: "请选择日期",
      trigger: "change"
    }
  ],
  date2: [
    {
      type: "date",
      required: true,
      message: "请选择时间",
      trigger: "change"
    }
  ],
  type: [
    {
      type: "array",
      required: true,
      message: "请至少选择一个活动性质",
      trigger: "change"
    }
  ],
  resource: [
    {
      required: true,
      message: "请选择活动资源",
      trigger: "change"
    }
  ],
  desc: [
    {
      required: true,
      message: "请填写活动形式",
      trigger: "blur"
    }
  ]
}

const descriptor = {
  name: {
    type: "string",
    required: true,
    validator: (rule, value) => value === "muji"
  },
  age: {
    type: "number",
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api
          .request({
            url: biz_data_helper.get_endpoint("test_fetch").url,
            parameters: {
              c: "a666"
            }
          })
          .then(res => {


            if (value == res.data[0].echo) {
              resolve(res)
            } else {
              reject("测试没通过")
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const methods = {
  ///get
  async getData(_params) {
    const biz_data = new biz_data_helper.base_entity_helper(
      "get_PurchLineReturnInfo",
      {},
      {}
    )
    let result = await biz_data
      .execAction({
        params: _params,
        fields: _.map(fields, "key")
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///save
  async saveData(items) {
    let add_list = [],
      update_list = []
    _.each(items, t => {
      if (_.isInteger(t.id)) {
        update_list.push(t)
      } else {
        let _t = _.cloneDeep(t)
        delete _t.id
        add_list.push(_t)
      }
    })

    let _actions = []
    if (add_list.length > 0) {
      _.each(add_list, t => {
        _actions.push(
          biz_data
            .insertAction({
              params: t,
              fields: _.map(fields.default, "key")
            })
            .action({})
        )
      })
    }
    if (update_list.length > 0) {
      _.each(update_list, t => {
        _actions.push(
          biz_data
            .updateAction({
              params: t,
              fields: _.map(fields.default, "key")
            })
            .action({})
        )
      })
    }

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  ///del
  async deleteData(items) {
    let _actions = []
    _.each(items, t => {
      _actions.push(
        biz_data
          .deleteAction({
            params: {
              id: t.id
            }
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return true
    } else {
      return false
    }
  },
  ///approve
  async approveData(items) {
    let _actions = []
    _.each(items, t => {
      _actions.push(
        biz_data
          .approveAction({
            params: {
              id: t.id,
              is_approved: t.is_approved
            }
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return true
    } else {
      return false
    }
  }
}
export { biz_data, dataForm, fields, methods, rules };

